import { type ButtonSpinnerProps } from '../constants/skeleton'

export function ButtonSpinner({ label }: ButtonSpinnerProps) {
  return (
    <span className="btn-spinner" aria-hidden="true">
      <span className="btn-spinner__ring" />
      {label ? <span className="btn-spinner__label">{label}</span> : null}
    </span>
  )
}
